import {
  Drawer,
  DrawerPosition,
  ScrollArea,
  Title,
  useMantineTheme
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

import { BankAccountForm } from '@/containers/forms'
import { BankAccount as BankAccountType } from '@/types'

interface Props {
  open: boolean
  position?: DrawerPosition
  onClose: () => void
  onSelect?: (bankAccount: BankAccountType) => void
  bankAccount?: BankAccountType | null
}

export default function BankAccountDrawer({
  open,
  position = 'right',
  onClose,
  onSelect,
  bankAccount = null
}: Props) {
  // Hooks
  const theme = useMantineTheme()
  const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)

  const isEditing = Boolean(bankAccount?.uid)
  const title = isEditing
    ? bankAccount?.transferMethod === 'pix'
      ? 'Editar chave Pix'
      : 'Editar conta bancária'
    : 'Conta bancária'

  return (
    <Drawer
      opened={open}
      onClose={onClose}
      padding="lg"
      size={isXs ? 'full' : 'xl'}
      title={<Title order={3}>{title}</Title>}
      position={position}>
      <ScrollArea style={{ height: 'calc(100vh - 100px)' }} offsetScrollbars>
        <BankAccountForm.Order
          key={bankAccount?.uid || 'create-bank-account'}
          handleCloseDrawer={onClose}
          onSelect={onSelect}
          bankAccount={bankAccount}
        />
      </ScrollArea>
    </Drawer>
  )
}
